



































import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Auction } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) readonly auction: Auction;
}
